import type { UserConfig } from '@lemonade-hq/nuiza';
import { Client, useUserContext } from '@lemonade-hq/nuiza';
import { useNavContext } from '@lemonade-hq/uniclient-app';
import { useCallback, useEffect } from 'react';

interface UseUserAuthDetailsProps {
  readonly userPublicId?: string;
}

export const useUserAuthDetails = ({ userPublicId }: UseUserAuthDetailsProps): void => {
  const {
    auth: { userInfoUrl },
  } = useNavContext();
  const { updateUser: updateUserContext } = useUserContext();

  const updateUser = useCallback(async (): Promise<void> => {
    if (userPublicId == null) return;

    try {
      const data = await Client.get<UserConfig>(userInfoUrl);
      updateUserContext(data);
    } catch (error: unknown) {
      // ignore error for unauthorized user
    }
  }, [userInfoUrl, updateUserContext, userPublicId]);

  useEffect(() => {
    void updateUser();
  }, [updateUser]);
};
